var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserForm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M39 6h-5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h4a1 1 0 0 1 1 1v32a1.02 1.02 0 0 1-1 1H10a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h4a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H9a4 4 0 0 0-4 4v34a4 4 0 0 0 4 4h30a4 4 0 0 0 4-4V10a4 4 0 0 0-4-4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18 12a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V6a6 6 0 0 0-12 0Zm4-7a2 2 0 1 1 2 2 2 2 0 0 1-2-2ZM18.24 23.76a10.34 10.34 0 0 0 2.22 7.14 2.16 2.16 0 0 1 0 1.5c-4.1 1.52-6.36 2.62-7.26 4.42a10.56 10.56 0 0 0-.96 3 .96.96 0 0 0 .22.82.98.98 0 0 0 .76.36H35a.98.98 0 0 0 .76-.36.96.96 0 0 0 .22-.82 11.24 11.24 0 0 0-.96-3c-.9-1.8-3.16-2.9-7.22-4.4a2 2 0 0 1 0-1.48 10.34 10.34 0 0 0 2.2-7.18A6 6 0 0 0 26.52 18a6.5 6.5 0 0 0-4.8 0 6 6 0 0 0-3.48 5.76Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserForm);
export default __webpack_public_path__ + "static/media/user-form.44224c5f.svg";
export { ForwardRef as ReactComponent };